// Blobを指定ファイル名でブラウザにダウンロードさせる共通処理。
// createObjectURL→<a>クリック→revokeの定型を1か所にまとめる。
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
